import styled from '@emotion/styled';
import { Section } from '@/components/pages/about/comm/Layout';
import { breakpointMdSmall } from '@/components/pages/about/comm/lib/custom-breakpoint.service';
import CertiTryoutInfo from '@/components/pages/about/main/CertiTryoutInfo';
import { breakpointMedium } from '@/constants/breakpoints';

const CertiDetailSection = () => {
  return (
    <Section.Container>
      <StyledSectionInner>
        <Section.Hgroup>
          <Section.Title>
            초보자부터 전문가까지 다양한 언어와 과목으로 자격증을 취득할 수 있어요.
          </Section.Title>
          <Section.Subtitle>
            SQL부터 프로그래밍 문법, SW에 대한 구현 능력까지
            다양한 수준과 언어로 출제된 코딩테스트를 경험해보세요. <br />{' '}
            관련 분야 최고 권위자들과 협업을 통해 최신 기술을 포함한 다양한 문제들로 구성하여 가장 효과적인 역량 평가를 제공합니다.
          </Section.Subtitle>
        </Section.Hgroup>

        <StyledSectionList>
          <CertiTryoutInfo classification="PCSQL" />
          <CertiTryoutInfo classification="PCCE" />
          <CertiTryoutInfo classification="PCCP" />
        </StyledSectionList>
      </StyledSectionInner>
    </Section.Container>
  );
};

export default CertiDetailSection;

const StyledSectionInner = styled(Section.Inner)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 80px 16px;
  gap: 100px;

  @media (max-width: ${breakpointMedium}) {
    padding: 60px 20px;
    gap: 80px;
  }
`;

const StyledSectionList = styled(Section.List)`
  gap: 48px;

  @media (max-width: ${breakpointMdSmall}) {
    gap: 64px;
  }
`;
